import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-vue-portefeuille",
  templateUrl: "./vue-portefeuille.component.html",
  styleUrls: ["./vue-portefeuille.component.scss"],
})
export class VuePortefeuilleComponent implements OnInit {
  constructor() {}
  ngOnInit(): void {
  
  }

}
